export default __webpack_public_path__ + "static/1054-f64077337f67ccf07d020e438de64b5c.gif";